// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"89":"7f9f9cf3","626":"962c182f","762":"8e02f343"}[chunkId] + ".chunk.css";
};